import { localesModulesEN } from '@modules/locales'
import { localesComponentsEN } from 'ui-components/locales'

const locales = {
  ...localesModulesEN,
  ...localesComponentsEN,
}

export default locales
